import type { EnvironmentConfig } from "./development";

/**
 * Test environment configuration
 */
export const testConfig: EnvironmentConfig = {
  // API Configuration
  apiTimeout: 30000,
  enableMockData: true,
  enableDebugMode: true,

  // Logging Configuration
  logLevel: "warn",
  enableConsoleLogging: true,
  enableNetworkLogging: true,

  // Performance Configuration
  enablePerformanceMonitoring: true,
  enableSourceMaps: true,

  // Feature Flags
  features: {
    enableNewUI: true,
    enableExperimentalFeatures: true,
    enableBetaFeatures: true,
  },

  // Development Tools
  enableDevTools: true,
  enableHotReload: true,
  enableErrorBoundary: true,

  // Cache Configuration
  cacheTimeout: 10 * 60 * 1000, // 10 minutes
  enableCaching: false, // Disable caching in test
};
